export default "__VITE_ASSET__BPauFSm3__"